import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { BrandService } from '../proxy/general/controllers/brand.service';
import { ModelService } from '../proxy/general/controllers/model.service';

FieldBuilder.setNamespace('General');

export const HEADER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Header.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder.foreignKey('brandId', 'Entity.Brand', BrandService)
    .displayFromNested('brand.name')
    .sortBy('brand.name')
    .build(),
  FieldBuilder.foreignKey('modelId', 'Entity.Model', ModelService)
    .displayFromNested('model.name')
    .sortBy('model.name')
    .build(),
];

export const HEADER_CONFIG = {
  entityName: 'Header',
  localizationKey: 'General::Entity.Header',
  fields: HEADER_FIELDS,
  permission: 'GeneralMachinesAndVehicles.Headers',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
